module.exports = __webpack_public_path__ + "static/media/palmTreeBroken.cdd7e00d.png";